import { get } from 'epics/ajax';
import type { AjaxError } from 'rxjs';
import { Observable } from 'rxjs';
import { getMeta } from 'util/meta';
import type { ExternaLinksAjaxResponse, ExternalLinksReponse } from './types';

export const fetchExternalLinks = (projectId: number): Observable<ExternalLinksReponse> => {
    const tenantId = getMeta('tenant-id') || '';
    const url = `/gateway/api/jira/wormhole/cloudid/${tenantId}/api/v1/external-links/project/${projectId}`;
    return get(url)
        .map(({ response }: ExternaLinksAjaxResponse) => response)
        .catch((e: AjaxError) => {
            return Observable.throw(e);
        });
};
